import React from 'react';
import { H2 } from '../forms';
import { ButtonContainer, FormContainer } from '../layoutComponents';
import { Body2, Button } from '../../components/common';
import { useMessageGetter } from 'react-message-context';

type Props = {
  onContinue: () => void;
};

const SuccessStep: React.FC<Props> = ({ onContinue }) => {
  const t = useMessageGetter('ysaatio.signup.success');
  return (
    <FormContainer>
      <H2>{t('title')}</H2>
      <Body2>{t('description')}</Body2>
      <ButtonContainer>
        <Button primary onClick={onContinue}>
          {t('button')}
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};

export default SuccessStep;
